import { render, staticRenderFns } from "./Haakpatroon.vue?vue&type=template&id=2a9045f5&scoped=true"
import script from "./Haakpatroon.vue?vue&type=script&lang=js"
export * from "./Haakpatroon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9045f5",
  null
  
)

export default component.exports